export default __webpack_public_path__ + "book_details-lexile.2c97b630.png";